<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" width="800px" :close-on-click-modal="false" @close="close">
    <el-form ref="form" :model="form" label-width="180px">
      <el-form-item :label="$t('rider.level.levelTitle')" prop="name" :required="true">
        <el-input v-model.trim="form.name" autocomplete="off" :placeholder="$t('rider.level.levelNamePh')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('rider.level.levelSetting')" prop="level" :required="true">
        <el-select v-model="form.level" :disabled="dislabel" :placeholder="$t('common.pleaseSelect')">
          <el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('rider.level.levelIcon')" :required="true" prop="icon">
        <div class="uploadSource bor_de rel flex" v-if="form.icon">
          <label class="statusLabel curs" @mouseenter="enter(1)" @mouseleave="leave(1)">
            <i class="el-icon-check" ref="imgicon1"></i>
            <i class="el-icon-close" @click="deleteMultiImage(form.icon, 1)"></i>
          </label>
          <img :src="form.icon" @click="test(1)" class="wid" />
        </div>
        <div class="uploadSource flex-center curs" v-else @click="test(1)">
          <i class="el-icon-plus fon_40 color_d9"></i>
        </div>
      </el-form-item>
      <el-form-item :label="$t('rider.level.dailyMerge')" :required="true" prop="receiptNum">
        <el-input v-model.trim="form.receiptNum" autocomplete="off" :placeholder="$t('rider.level.dailyMergePh')">
          <template slot="append">{{ $t('common.order') }}</template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('rider.level.dailyTransfer')" :required="true" prop="transferNum">
        <el-input v-model.trim="form.transferNum" autocomplete="off" :placeholder="$t('rider.level.dailyTransferPh')">
          <template slot="append">{{ $t('common.order') }}</template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('rider.level.dailyCancel')" :required="true" prop="cancelNum">
        <el-input v-model.trim="form.cancelNum" autocomplete="off" :placeholder="$t('rider.level.dailyCancelPh')">
          <template slot="append">{{ $t('common.order') }}</template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('rider.level.commissionRatio')" :required="true" prop="ratio">
        <el-input v-model.trim="form.ratio" autocomplete="off" :placeholder="$t('rider.level.commissionRatioPh')">
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('rider.level.upgradeCondition')" prop="upgradeNum" :required="true">
        <el-input v-model.trim="form.upgradeNum" autocomplete="off" :placeholder="$t('rider.level.upgradeConditionPh')">
          <template slot="append">{{ $t('common.order') }}</template>
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button size="medium" type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
    </div>
    <attachment-img ref="img1" type="img" @attachment="imgadd1"></attachment-img>
  </el-dialog>
</template>

<script>
import attachmentImg from '@/plugins/attachment-img';
import { saveLevel, getSaveLevel } from '@/api/rider';
export default {
  name: 'labelSave',
  created() {},
  components: {
    attachmentImg
  },
  data() {
    return {
      form: {
        id: '',
        name: '',
        receiptNum: '',
        transferNum: '',
        cancelNum: '',
        icon: '',
        ratio: '',
        upgradeNum: '',
        level: ''
      },
      title: '',
      dialogFormVisible: false,
      dislabel: false
    };
  },
  computed: {
    levelOptions() {
      return Array.from({ length: 20 }, (_, index) => {
        const n = index + 1;
        return {
          value: n,
          label: this.$t('rider.level.levelN', { n }),
        };
      });
    },
  },

  methods: {
    showEdit(id) {
      if (!id) {
        this.title = this.$t('common.add');
        this.dislabel = false;
      } else {
        this.title = this.$t('common.edit');
        this.dislabel = true;
        this.getInfo(id);
      }
      this.dialogFormVisible = true;
    },
    close() {
      this.$refs['form'].resetFields();
      this.form = this.$options.data().form;
      this.dialogFormVisible = false;
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const { msg } = await saveLevel(this.form);
          this.$baseMessage(msg, 'success');
          this.$emit('fetchData');
          this.close();
        } else {
          return false;
        }
      });
    },
    async getInfo(id) {
      const { data } = await getSaveLevel({ id: id });
      Object.assign(this.form, data);
    },
    enter(i = 0) {
      this.$refs['imgicon' + i].style.display = 'none';
    },
    leave(i = 0) {
      this.$refs['imgicon' + i].style.display = 'inline-block';
    },
    test(i = 0) {
      this.$refs['img' + i].dialogVisible = true;
    },
    imgadd1(url) {
      this.form.icon = url.str;
    },
    deleteMultiImage(item, index, type) {
      Array.prototype.remove = function (val) {
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      if (!type) {
        switch (index) {
          case 1:
            this.form.icon = '';
            break;
        }
      }
    }
  }
};
</script>
